import { useAppStore } from '../../store/app'
import { NavBar, NavBarButton } from '../../components/NavBar'
import { GrantsSegment } from './segments/GrantsSegment'
import './AgentGrantsScreen.css'

export function AgentGrantsScreen({ positionID }: { positionID: string }) {
  const popNav = useAppStore((s) => s.popNav)
  return (
    <div className="agent-grants-screen">
      <NavBar
        title="Smart Rules"
        leading={<NavBarButton icon="‹" label="Back" onClick={popNav} />}
      />
      <GrantsSegment positionID={positionID} />
    </div>
  )
}
